/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CounterIcon20Solid = forwardRef('CounterIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.1 9a.9.9 0 1 1 1.8 0v2a.9.9 0 1 1-1.8 0V9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm2 2.9A2.1 2.1 0 0 0 4.9 9v2a2.1 2.1 0 1 0 4.2 0V9A2.1 2.1 0 0 0 7 6.9Zm5.1-1.895V7a.9.9 0 1 0 1.8 0V5.005h1.2V7a2.1 2.1 0 1 1-4.2 0V5.005h1.2Zm2 6.098a.6.6 0 0 0-.964-.477l-1.834 1.402a.6.6 0 0 0 .728.953l.87-.664v2.686h1.2v-3.9Z" })));
});
